import { VIDEO_VARIANTS } from '@workspace/constants';
import { AppVideoImage, Picture } from '@/app/common';
import type { SanityImage } from '@workspace/interfaces';

interface ImageTextMediaProps {
  isVideo: boolean;
  video?: string;
  image: SanityImage;
  imagePosition: boolean;
}

export function ImageTextMedia({ isVideo, video, image }: ImageTextMediaProps) {
  if (isVideo && video) {
    return <AppVideoImage video={video} variant={VIDEO_VARIANTS.VideoWithoutText} wrapperClassName="h-full" />;
  }

  return image?.url ? (
    <Picture
      image={image}
      alt={image.bynderImage?.alt || image.alt || ''}
      desktopWidth={544}
      desktopHeight={544}
      imgClassName="w-full h-81.75 md:w-136 md:h-136 md:mx-auto"
    />
  ) : (
    <div className="bg-placeholder! w-full h-81.75 md:w-136 md:h-136 md:mx-auto"></div>
  );
}
